import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"top":"","color":_vm.notification.color},model:{value:(_vm.notification.show),callback:function ($$v) {_vm.$set(_vm.notification, "show", $$v)},expression:"notification.show"}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }